import React from 'react';
import { Progress } from 'semantic-ui-react';
import styles from './resultTextPollQuestion.css';
import { getSwitchClassNameOrColourWithBackground } from '../../../../../../../../utils/func';

/**
 *
 * @type {React.NamedExoticComponent<{readonly settings?: *, readonly question?: *, readonly responseAnswersQuestion?: *}>}
 */
const ResultTextPollQuestion = React.memo( ( { responseAnswersQuestion, settings, question } ) => {

    const isImagePositionCover = question.localization.image_position === 'cover';
    const textAutoColorClass = isImagePositionCover ? 'darkBgPlaceholder' : getSwitchClassNameOrColourWithBackground( settings.appearance.background_color, 'lightBgPlaceholder', 'darkBgPlaceholder' );

    return (
        <div className={ styles.wrapper }>
            { responseAnswersQuestion && responseAnswersQuestion.poll_results.map( ( el, i ) => {
                return (
                    <div className={ styles.wrapperItem } key={ i }>
                        <div className={ `${ styles.itemText } ${ styles[ textAutoColorClass ] }` }>
                            <p className={ styles.text }>{ el.text }</p>
                            <p className={ `${ styles.answersPercent } ${ styles[ textAutoColorClass ] }` }>
                                { `${ el.answersPercent } %` }
                            </p>
                        </div>
                        <Progress className={ styles.itemProgress } percent={ el.answersPercent } size='small'/>
                    </div>
                );
            } ) }
        </div>
    );
} );

export default ResultTextPollQuestion;